/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProcedureGenerationOutputDto } from './ProcedureGenerationOutputDto';
import {
    ProcedureGenerationOutputDtoFromJSON,
    ProcedureGenerationOutputDtoFromJSONTyped,
    ProcedureGenerationOutputDtoToJSON,
    ProcedureGenerationOutputDtoToJSONTyped,
} from './ProcedureGenerationOutputDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface ProcedureListResponseDto
 */
export interface ProcedureListResponseDto {
    /**
     * List of procedures
     * @type {Array<ProcedureGenerationOutputDto>}
     * @memberof ProcedureListResponseDto
     */
    procedures?: Array<ProcedureGenerationOutputDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof ProcedureListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the ProcedureListResponseDto interface.
 */
export function instanceOfProcedureListResponseDto(value: object): value is ProcedureListResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ProcedureListResponseDtoFromJSON(json: any): ProcedureListResponseDto {
    return ProcedureListResponseDtoFromJSONTyped(json, false);
}

export function ProcedureListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcedureListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'procedures': json['procedures'] == null ? undefined : ((json['procedures'] as Array<any>).map(ProcedureGenerationOutputDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function ProcedureListResponseDtoToJSON(json: any): ProcedureListResponseDto {
    return ProcedureListResponseDtoToJSONTyped(json, false);
}

export function ProcedureListResponseDtoToJSONTyped(value?: ProcedureListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'procedures': value['procedures'] == null ? undefined : ((value['procedures'] as Array<any>).map(ProcedureGenerationOutputDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

